import { GaFormFieldInputText } from "@/components/form/GaFormFieldInputText";
import { GaButton } from "@/components/general/GaButton";
import { useCustomModal } from "@/components/general/GaModal";
import { useGaContext } from "@utils/vue-migration/common/gaContext/gaContext";
import { addToast } from "@/components/general/GaToast";
import { trackShareEvent } from "@generated/api/analyticTrackingControllerApi";
import type { ContentItemType } from "@utils/type/type";
import type { GaVueComponent } from "@/common/vueUtils";
import type { TranslationFn } from "@utils/vue-migration/common/gaContext/gaContextTranslations";

const getLocalizedContentItemName = (t: TranslationFn, contentItemType: ContentItemType): string => {
  switch (contentItemType) {
    case "UNKNOWN": {
      throw new Error('Not implemented yet: "UNKNOWN" case');
    }
    case "SUMMARY": {
      throw new Error('Not implemented yet: "SUMMARY" case');
    }
    case "CATEGORY": {
      throw new Error('Not implemented yet: "CATEGORY" case');
    }
    case "CHANNEL": {
      throw new Error('Not implemented yet: "CHANNEL" case');
    }
    case "LGXP": {
      throw new Error('Not implemented yet: "LGXP" case');
    }
    case "ACTIONABLE": {
      return t("general:link.actionable", "general:link.actionable");
    }
    case "MYLIST": {
      throw new Error('Not implemented yet: "MYLIST" case');
    }
    case "CUSTOMPAGE": {
      throw new Error('Not implemented yet: "CUSTOMPAGE" case');
    }
    case "EXPERT_VIDEO": {
      return t("general:link.expertVideos", "general:link.expertVideos");
    }
    case "MIAB": {
      return t("general:link.miab", "general:link.miab");
    }
  }
};

export function useShareModal(props: { slots: GaVueComponent; link: string; contentItemType: ContentItemType; contentId: bigint }): () => Promise<void> {
  const { t } = useGaContext();

  return () =>
    useCustomModal()({
      body: () => (
        <div class="shareModal">
          <div class="shareModal__description">
            <h3>{t("general:page.shareModal.title")}</h3>
            <p>{t("general:page.shareModal.description", [getLocalizedContentItemName(t, props.contentItemType)])}</p>
          </div>
          <div class="shareModal__summary">{props.slots}</div>
          <div class="shareModal__shareLink">
            <p class="caption">{t("general:page.shareModal.linkCaption")}</p>
            <GaFormFieldInputText name="miabShareLink" value={props.link} onUpdateValue={() => void 0} disabled={true} />
            <div class="shareModal__shareLinkButton">
              <GaButton onClick={() => copyToClipboard(props.link, t("general:page.shareModal.copySuccessful") ?? "", props.contentId, props.contentItemType)}>{t("general:page.shareModal.copyLink")}</GaButton>
            </div>
          </div>
        </div>
      ),
      size: "lg",
    });
}

async function copyToClipboard(link: string, successMessage: string, dataId: bigint, contentItemType: ContentItemType): Promise<void> {
  await navigator.clipboard.writeText(link);
  addToast({
    message: successMessage,
  });
  await trackShareEvent({ id: dataId, contentItemType: contentItemType, shareMedium: "COPY_LINK" });
}
